"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOppositeLocale = exports.getLocaleFlagCountryCode = exports.canTranslateForms = void 0;
const country_1 = require("../enums/country");
const locales_1 = require("../enums/locales");
const canTranslateForms = (country) => {
    return (country === country_1.OrganizationCountry.Canada ||
        country === country_1.OrganizationCountry.UnitedStates ||
        country === country_1.OrganizationCountry.Germany);
};
exports.canTranslateForms = canTranslateForms;
const ENGLISH_FLAG_BY_COUNTRY = {
    [country_1.OrganizationCountry.UnitedStates]: country_1.CountryCode.US,
    [country_1.OrganizationCountry.Australia]: country_1.CountryCode.AU,
    [country_1.OrganizationCountry.NewZealand]: country_1.CountryCode.NZ,
    [country_1.OrganizationCountry.Ireland]: country_1.CountryCode.IE,
};
const FLAG_BY_LOCALE = {
    [locales_1.Locales.EN]: country_1.CountryCode.GB,
    [locales_1.Locales.FR]: country_1.CountryCode.FR,
    [locales_1.Locales.ES]: country_1.CountryCode.ES,
    [locales_1.Locales.DE]: country_1.CountryCode.DE,
};
const getLocaleFlagCountryCode = (locale, organizationCountry) => {
    if (locale === locales_1.Locales.EN && organizationCountry) {
        return ENGLISH_FLAG_BY_COUNTRY[organizationCountry] ?? FLAG_BY_LOCALE[locales_1.Locales.EN];
    }
    return FLAG_BY_LOCALE[locale];
};
exports.getLocaleFlagCountryCode = getLocaleFlagCountryCode;
const getOppositeLocale = ({ organizationCountry, locale }) => {
    if (!organizationCountry || !locale) {
        return locales_1.Locales.EN;
    }
    if (organizationCountry === country_1.OrganizationCountry.UnitedStates) {
        return locale === locales_1.Locales.EN ? locales_1.Locales.ES : locales_1.Locales.EN;
    }
    if (organizationCountry === country_1.OrganizationCountry.Germany) {
        return locale === locales_1.Locales.DE ? locales_1.Locales.EN : locales_1.Locales.DE;
    }
    if (organizationCountry === country_1.OrganizationCountry.GreatBritain) {
        return locale === locales_1.Locales.FR ? locales_1.Locales.EN : locales_1.Locales.FR;
    }
    return locale === locales_1.Locales.FR ? locales_1.Locales.EN : locales_1.Locales.FR;
};
exports.getOppositeLocale = getOppositeLocale;
